import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-left"
}
const _hoisted_2 = {
  key: 0,
  class: "mt40"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"header_title fs18 fl\" style=\"\"><p class=\"header_title fs18 fl\" style=\"\">振り分けフォームを設置</p><div class=\"clear\"></div><p class=\"fs13 fl dgrey\" style=\"\"> 公開ボードに振り分けフォームを設置することができます。<br> 設置すると、公開ボードのページに振り分けフォームが表示され、フォーム回答後、指定した公開ページ・URLに遷移することができます。<br> 以下に振り分けフォームのIDを入力してください。 </p><div class=\"clear\"></div></div><div class=\"clear\"></div>", 2)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "fs11 fw600"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!

  return (_ctx.rcm && _ctx.rcm.room)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.from == `public_room`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_MdTextfieldTag, {
                name: "振り分けフォームIDを入力",
                fieldStyle: "min-width:250px;max-width:250px;",
                style: {"height":"56px","min-width":"250px"},
                class: "fs16 fl",
                value: _ctx.publicId,
                onInputValue: _ctx.inputAssignFormPublicId,
                required: ""
              }, null, 8, ["value", "onInputValue"]),
              _createElementVNode("div", {
                class: "fl greyBg rad5 mt16 fs11 pointer hoverGreyBg",
                style: {"padding":"13px","height":"40px"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickConnectAssignForm && _ctx.clickConnectAssignForm(...args)))
              }, " 紐付け "),
              _hoisted_5,
              (_ctx.selectedForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 「" + _toDisplayString(`[${_ctx.selectedForm.public_id}]${_ctx.selectedForm.title}`) + "」の振り分けフォームを紐付けています。 ", 1))
                : _createCommentVNode("", true),
              _hoisted_7
            ]))
          : _createCommentVNode("", true),
        _hoisted_8
      ]))
    : _createCommentVNode("", true)
}